module.exports = __webpack_public_path__ + "img/18.eaec4a26.jpg";